import { render, staticRenderFns } from "./MarketplaceApiSubmenu.vue?vue&type=template&id=4f9745c4&"
import script from "./MarketplaceApiSubmenu.vue?vue&type=script&lang=js&"
export * from "./MarketplaceApiSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports